<template>
    <div class="tsa-copyrightAuthSuccess">
        <div class="breadcrumb">
            <span class="title">版权（著作权）认证成功</span>
        </div>
        <div class="certificate-container">
            <!-- <div class="float-btn">
                <TsaButton plain size="smaller" @click="gotoIndex">认证新作品</TsaButton>
            </div> -->
            <div class="share-work" @click="shareWorks">
                <p>分享作品</p>
            </div>
            <div class="status">
                <img src="../../../assets/images/success_icon.png" alt="">
                <div class="text">
                    <h4>版权（著作权）认证成功</h4>
                    <p>已为您生成版权认证证书</p>
                </div>
            </div>
            <!-- <TsaSubTitle>可信时间戳版权认证证书</TsaSubTitle> -->
            <div class="images">
                <img :src="certificateInfo.certThumbnailStorePathUrl" @click="preview(certificateInfo.certThumbnailStorePathUrl)" class="image" alt="">
                <img :src="certificateInfo.enCertThumbnailStorePathUrl" @click="preview(certificateInfo.enCertThumbnailStorePathUrl)" class="image" alt="">
            </div>
            <div class="btn-group">
                <div class="btn" @click="download">
                    <span class="tsa-icon-download2"></span>
                    <p>下载证书</p>
                </div>
                <div class="btn" @click="settingPermissions">
                    <span class="tsa-icon-bianjilan"></span>
                    <p>访问权限设置</p>
                </div>
            </div>
        </div>
        <div class="detail-container">
            <h2 class="">作品认证详情</h2>
            <TsaRightsInfo :result="rightsInfo"></TsaRightsInfo>
            <TsaBasicInfo :result="basicInfo"></TsaBasicInfo>
            <TsaProductionTeam :result="productionTeam" v-if="type==1"></TsaProductionTeam>
            <TsaCreateProcess :data="createProcessList" fromPage="copyrightAuthSuccess" @on-loadAll="loadAll" @on-actions="actions"></TsaCreateProcess>
        </div>
        <TsaSharePermissionsSetting ref="sharePermissionsSettingDialog" @on-permissionsSettingSuccess="permissionsSettingSuccess"></TsaSharePermissionsSetting>
        <TsaShareWorksDialog ref="shareWorksDialog" @on-setting="settingPermissionsCommon"></TsaShareWorksDialog>
    </div>
</template>

<script>

import copyrightAuthSuccessCommon from '@/mixins/copyrightAuthSuccess'
import TsaSharePermissionsSetting from '@/components/copyright/business/sharePermissions/shareSettingDialog'
import TsaShareWorksDialog from '@/components/copyright/business/sharePermissions/shareWorksDialog'
export default {
    mixins: [ copyrightAuthSuccessCommon ],
    components: {
        TsaSharePermissionsSetting,
        TsaShareWorksDialog
    },
}
</script>

<style lang="scss" scoped>
    .tsa-copyrightAuthSuccess {
        width: 100%;
        height: 100%;
        padding:0 12px 12px;
        box-sizing: border-box;
        overflow: auto;
        .breadcrumb{
            display: flex;
            justify-content: space-between;
            padding: 12px 4px;
            span{
                font-size: 14px;
                color: #333;
                &.title{
                    font-weight: bold;
                }
                &.back{
                    font-size: 12px;
                }
            }
        }
        h2 {
            font-size: 18px;
            font-weight: bold;
        }
        .certificate-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 16px 0;
            border-radius: 12px;
            background: #fff;
            margin-bottom: 16px;
            position: relative;
            .share-work{
                width: 100%;
                display: flex;
                justify-content: flex-end;
                box-sizing: border-box;
                padding: 0 12px 0;
                p{
                    width: 91px;
                    height: 29px;
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 8px;
                    font-size: 14px;
                }
            }
            .float-btn {
                width: 100px;
                position: absolute;
                right: 16px;
                top: 16px;
            }
            .status {
                display: flex;
                margin-left: -6px;
                img {
                    width: 66px;
                    height: 66px;
                    margin-right: 16px;
                }
                .text {
                    padding-top: 5px;
                    h4 {
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        margin-bottom:5px;
                    }
                    p {
                        font-size: 14px;
                        color: #000000;
                    }
                }
            }
            .tsa-subTitle {
                margin-bottom: 16px;
            }
            .images {
                display: flex;
                .image {
                    width: 150px;
                    height: 200px;
                    cursor: pointer;
                    border: 1px solid #FFFFFF;
                    margin-bottom: 20px;
                    &:hover {
                        border: 1px solid #205EFF;
                    }
                    &:last-child {
                        margin-left: 20px;
                    }
                }
            }
            .btn-group {
                display: flex;
                align-items: center;
                .btn {
                    padding: 0 5px;
                    height: 26px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    border: 1px solid #0047FF;
                    cursor: pointer;
                    // &:hover {
                    //     background: #0047FF;
                    //     span {
                    //         color: #ffffff;
                    //     }
                    //     p {
                    //         color: #ffffff;
                    //     }
                    // }
                    &:last-child {
                        margin-left: 20px
                    }
                    span {
                        font-size: 16px;
                        font-weight: bold;
                        color: #0047FF;
                        margin-right: 2px;
                    }
                    p {
                        font-size: 14px;
                        color: #0047FF;
                    }
                }
            }
        }
        .detail-container {
            background: #FFFFFF;
            border-radius: 12px;
            padding-top: 32px;
            h2 {
                font-weight: bold;
                font-size: 16px;
                color: #000000;
                text-align: center;
                margin-bottom: 20px;
            }
            .tsa-basicInfo {
                padding-top: 0;
                margin-bottom: 16px;
            }
            .tsa-productionTeam {
                padding-top: 16px;
                margin-bottom: 16px;
            }
            .tsa-createProcess {
                padding-top: 16px;
                margin-bottom: 16px;
            }
        }
    }
</style>